<template>
  <div class="about" style="width: 100%" v-if="this.game">
    <b-container style="width: 100%">
      <b-row>
        <b-col class="padded pointer" style="height: 100%" sm="5" v-if="game.cover">
          <b-img v-b-modal.modal-cover style="width: 100%" rounded :src="url" @load="onImageLoaded"/>
          <b-modal size="l" :hide-footer="true" :hide-header="true" ok-variant="secondary" id="modal-cover">
            <img :src="url" @load="onImageLoaded" @click="$bvModal.hide('modal-cover')"/>
            <div class="modalOverlay" @click="$bvModal.hide('modal-cover')"></div>
          </b-modal>
        </b-col>
        <b-col sm="7" class="padded" v-if="game.cover">
          <b-container class="rounded padded containerStyling">
            <b-row>
              <b-col>
                <h1 class="game-title">{{ this.game.name }}</h1>
              </b-col>
            </b-row>
            <b-row>
              <b-col style="padding-top: 2rem; padding-bottom: 2rem;">
                <h5 v-if="releaseDates && releaseDates.length">{{ isAfterNow(earliestReleaseDate()) ? "Will be" : "Was" }} released in {{ releaseDate() }}</h5>
              </b-col>
            </b-row>
            <b-row>
              <b-col class="genre-wrapper">
                <div class="genre-box">
                  <h6 class="card-text text-left-align">Genre</h6>
                  <b-badge class="badge" pill variant="secondary" :key="genre" v-for="genre in game.genres">{{ genre }}</b-badge>
                </div>
              </b-col>
              <b-col class="theme-wrapper">
                <div class="theme-box">
                  <h6 class="card-text text-left-align">Themes</h6>
                  <b-badge class="badge" pill variant="secondary" :key="theme" v-for="theme in game.themes">{{ theme }}</b-badge>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <div class="desc-wrapper" v-if="game.summary && game.summary.length">
                  <h6 class="card-text text-left-align" style="margin-bottom: 1rem;">Description</h6>
                  <p id="desc" class="card-text fulljustify no-left-padding">{{ game.summary }}</p>
                </div>
              </b-col>
            </b-row>
          </b-container>
        </b-col>
        <b-col v-if="!game.cover" sm="12">
          <b-container class="rounded padded">
            <div v-if="game.genres && game.genres.length">
              <h5 class="card-text topPaddingSeparator">Genre</h5>
              <span :key="genre" v-for="genre in game.genres">| {{ genre }} |</span>
            </div>
            <div style="topPaddingSeparator" v-if="releaseDates && releaseDates.length">
              <h5 class="card-text">Release date</h5>
              <p class="card-text">{{ releaseDate() }}</p>
            </div>
            <div v-if="game.themes && game.themes.length">
              <h5 class="card-text topPaddingSeparator">Themes</h5>
              <span :key="theme" v-for="theme in game.themes">| {{ theme }} |</span>
            </div>
            <div class="topPaddingSeparator" v-if="game.summary && game.summary.length">
              <h5 class="card-text">Description</h5>
              <p id="desc" class="card-text fulljustify">{{ game.summary }}</p>
            </div>
          </b-container>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="6" class="padded left">
          <b-container class="rounded containerStyling">
            <b-table :items="releaseDates" :fields="tableFields" />
          </b-container>
        </b-col>
        <b-col sm="6" class="padded" v-if="game.screenshots && game.screenshots.length">
          <b-container class="rounded padded containerStyling">
            <h5 class="card-text">Screenshots</h5>
            <span :key="screenshot" v-for="screenshot in game.screenshots">
              <img class="pointer" ref="btnShow" v-b-modal="screenshot" :src="screenshot"/>
              <b-modal :hide-footer="true" v-b-modal="screenshot" :hide-header="true" ok-variant="secondary" :id="screenshot">
                <img :src="openImg(screenshot)"/>
                <div class="modalOverlay" v-on="{ click: hideModal(screenshot) }"></div>
              </b-modal>
            </span>
          </b-container>
       </b-col>
      </b-row>
      <b-row>
        <b-col class="padded bottomCard" sm="12">
          <b-container v-if="game.involved_companies" class="rounded padded containerStyling">
            <h5 class="card-text">People behind this game</h5>
            <b-row>
              <b-col :key="company._id" v-for="company in game.involved_companies">
                <img v-b-popover.hover="company.company.description" :title="companyRole(company)+': '+company.company.name" v-if="company.company.logo" style="width: 100%; max-width: 250px" :src="logoImg(company.company.logo.url)" @load="onImageLoaded"/>
                <span style="font-size: 30px; font-weight: bold" v-b-popover.hover="company.company.description" :title="companyRole(company)+': '+company.company.name" v-if="!company.company.logo && company.company.name" >{{ company.company.name }}</span>
              </b-col>
            </b-row>
          </b-container>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'about',
  props: [
    'slug'
  ],
  metaInfo () {
    return {
      title: this.game ? this.game.name : '',
      titleTemplate: 'When is %s released?',
      htmlAttrs: {
        lang: 'en'
      },
      meta: [
        { description: `See release dates for ${this.game ? this.game.name : ''} for platforms including ${this.releaseDates ? this.platformString : ''}and many more. Game summary: ${this.game ? this.game.summary : ''}` },
        { name: 'ROBOTS', content: 'NOINDEX' }
      ]
    }
  },
  data () {
    return {
      game: null,
      releaseDates: [],
      tableFields: [
        {
          key: 'formattedDate',
          label: 'Date',
          sortable: false,
          thClass: 'tableCell',
          tdClass: 'tableCell'
        },
        {
          key: 'platform.abbreviation',
          label: 'Platform',
          sortable: false,
          thClass: 'tableCell',
          tdClass: 'tableCell'
        },
        {
          key: 'region',
          sortable: false,
          thClass: 'tableCell',
          tdClass: 'tableCell'
        }
      ]
    }
  },
  async mounted () {
    this.game = await this.fetchGameData()
    this.releaseDates = await this.fetchReleaseDates()
  },
  watch: {
    async $route (to, from) {
      this.game = await this.fetchGameData()
      this.releaseDates = await this.fetchReleaseDates()
    }
  },
  computed: {
    url: function () {
      // site breaks on cover undefined
      return this.game.cover.url ? this.game.cover.url.replace('thumb', 'original') : ''
    },
    platformString: function () {
      return this.releaseDates ? this.releaseDates.reduce((acc, cur) => {
        if (!acc.includes(cur.platform.name)) return acc + cur.platform.name + ', '
        return ''
      }, '') : ''
    }
  },
  methods: {
    hideModal (screenshot) {
      return () => this.$root.$emit('bv::hide::modal', screenshot, '#btnShow')
    },
    async fetchGameData () {
      const data = await this.$store.dispatch('getGameBySlug', this.slug)
      return data
    },
    async fetchReleaseDates () {
      const data = await this.$store.dispatch('getReleaseDatesByGameIgdbId', this.game.igdbId)

      let added = {}

      let results = data.map(rd => {
        if (!rd.platform.abbreviation) rd.platform.abbreviation = rd.platform.name
        return rd
      })

      results.map(rd => {
        if (!added[rd.platform.abbreviation + rd.region]) {
          added[rd.platform.abbreviation + rd.region] = rd
        } else {
          let alreadyAdded = moment(added[rd.platform.abbreviation + rd.region].updated_at)
          let newToTest = moment(rd.updated_at)

          if (added[rd.platform.abbreviation + rd.region].category > rd.category || newToTest.isAfter(alreadyAdded)) {
            added[rd.platform.abbreviation + rd.region] = rd
          }
        }
      })

      let filtered = Object.values(added)

      return filtered
    },
    onImageLoaded () {
      this.loaded = true
    },
    openImg (screen) {
      return screen.replace('thumb', 'original')
    },
    logoImg (url) {
      return url.replace('thumb', 'original')
    },
    releaseDate () {
      return this.earliestReleaseDate().formattedDate
    },
    earliestReleaseDate () {
      let earliest = null

      for (let date of this.releaseDates) {
        if (earliest === null || new Date(earliest.date) > new Date(date.date)) earliest = date
      }

      return earliest
    },
    isAfterNow (date) {
      return moment(date.date).isAfter(moment())
    },
    releaseDateFormat (releaseDate) {
      const date = new Date(releaseDate)
      // We need to get rid of this formatting at some point
      return date ? date.getUTCDate() + '.' + (date.getUTCMonth() + 1) + '.' + date.getUTCFullYear() : 'Not available'
    },
    companyRole (company) {
      for (let key in company) {
        if (company[key] === true) {
          return key.charAt(0).toUpperCase() + key.slice(1)
        }
      }
    }
  }
}
</script>
<style>
.modalOverlay {
  position: fixed;
  height: 100vh;
  width: 100vw;
  top: 0px;
  left: 0px;
}

.topPaddingSeparator {
  padding-top: 15px;
}

.containerStyling {
  border: 2px solid #00000000 !important;
  background-color: #1e252c81;
  height: 100%;
}

.tableCell {
  color: #cfd0d1;
  background: rgba(0, 0, 0, 0);
}

.padded {
  padding: 5px;
  margin: 0px;
}

.padded, .left {
  padding-right: 5px !important;
}

.padded, .right {
  padding-left: 5px !important;
}

.bottomCard {
  margin-bottom: 15px;
}

.modal-dialog {
  height: fit-content !important;
  margin: auto !important;
}

.modal-content {
  width: fit-content !important;
  margin: auto;
}

@supports (-moz-appearance:none) {
  .modal-dialog {
    background: none;
    position: fixed !important;
    display: block;
  }
  .modal-content {
    background: none !important;
    border: none !important;
    width: 100vw !important;
    left: 0% !important;
    margin: auto;
  }
  .modal-body {
    margin-left: auto;
    margin-right: auto;
    width: 50%;
    position: relative !important;
    left: 0% !important;
  }
}

.modal-body:not(:root:root){
    position: relative !important;
    left: 0% !important;
}

.modal-body {
  padding: 0px !important;
  height: fit-content;
  width: fit-content;
  position: absolute;
  left: 0% ;
}

@media all and (-webkit-min-device-pixel-ratio:0) and (min-resolution: .001dpcm) {
  .selector:not(*:root), .modal-body {
      position: absolute !important;
      left: 50% !important;
      height: fit-content;
      width: fit-content;
    }
  }

.modal-body /deep/ img {
  position: relative;
  left: -50%;
  max-height: 90vh;
  max-width: 90vw;
}

.pointer {
  cursor: pointer;
  pointer-events: auto;
}

.fulljustify {
  text-align: justify;
  text-justify: inter-word;
  padding: 5px;
  white-space: pre-line;
}

.game-title {
  padding-bottom: 0.5rem;
  border-bottom: solid 1px #505050;
}

.left-align {
  float: left;
}

.text-left-align {
  text-align: left;
}

.genre-wrapper {
  padding-right: 0px !important;
}

.genre-box {
  padding-top: 0.5rem;
  padding-bottom: 2.5rem;
  padding-left: 0.5rem;
  border-top: solid 1px #505050;
  border-bottom: solid 1px #505050;
  border-right: solid 1px #505050;
  height: 100%;
}

.theme-wrapper {
  padding-left: 0px !important;
}

.theme-box {
  padding-top: 0.5rem;
  padding-bottom: 2.5rem;
  padding-left: 0.5rem;
  border-top: solid 1px #505050;
  border-bottom: solid 1px #505050;
  height: 100%;
}

.badge {
  margin-right: 0.4rem;
  margin-bottom: 0.4rem;
  float: left;
}

.desc-wrapper {
  padding-top: 0.5rem;
  padding-bottom: 2.5rem;
  padding-left: 0.5rem;
}

.no-left-padding {
  padding-left: 0px;
}
</style>
